export const STATUS_PENDENTE_APROVACAO = 0
export const STATUS_APROVADO = 1
export const STATUS_NAO_APROVADO = 98
export const STATUS_BLOQUEADO = 99

export const StatusTitle = function (s) {
  if (typeof Status[s] === 'undefined') {
    return 'Unknow status code'
  }
  return Status[s].titulo
}

export const Status = {
  0: {titulo: 'Pendente', class: 'primary'},
  1: {titulo: 'Aprovado', class: 'success'},
  98: {titulo: 'Não Aprovado', class: 'dark'},
  99: {titulo: 'Bloqueado', class: 'danger'}
}

export const EstadoCivil = {
  1: 'Solteiro(a)',
  2: 'Casado(a)',
  3: 'Viúvo(a)',
  4: 'Separado(a)',
  5: 'Divorciado(a)',
  6: 'Amancebado(a)'
}

export const StatusDocumento = {
  0: {titulo: 'Aguardando o envio dos arquivos', class: 'warning'},
  1: {titulo: 'Em análise', class: 'info'},
  2: {titulo: 'Verificado', class: 'success'},
  3: {titulo: 'Ilegível', class: 'dark'},
  4: {titulo: 'Incorreto', class: 'danger'}
}



// WEBPACK FOOTER //
// ./src/domain/arrematantes/helpers/ArrematanteStatus.js